import { AppSelect, AppSelectProps } from 'components/core/Select/AppSelect';

import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import { useField } from 'formik';

type ForwardedSelectedProps = Omit<AppSelectProps, 'name' | 'value' | 'onBlur'>;

interface Props {
  isDirectVacations?: boolean;
  name: string;
  hideError?: boolean;
}

export const FormikAppSelect = ({ name, hideError, onChange, ...forwardProps }: Props & ForwardedSelectedProps) => {
  const [field] = useField(name);

  const change = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    field.onChange(event);
    onChange && onChange(event);
  };

  return (
    <>
      <AppSelect {...forwardProps} value={typeof field.value == "boolean" ? String(field.value) : field.value} onChange={change} name={name} onBlur={field.onBlur} />
      {!hideError && <AlluraFormikErrorMessage fieldName={name} />}
    </>
  );
};
